import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '../../common/modules/core';
import { SharedModule } from '../../common/modules/shared';
import { UserModule } from '../../common/modules/user';
import { BookingModule } from './booking/BookingModule';
import { ParentProfileModule } from './profile/parent/ParentProfileModule';
import { RegisterManagementModule } from './register-management/RegisterModule';

// // Services
import { BookingHolidayService, EmailService, AttendanceService } from '../services';
// Components
import { LoginComponent } from './login/LoginComponent'
import { AppComponent } from './AppComponent';
import { routing } from './AppRouting';

@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        SharedModule,
        UserModule,
        BookingModule,
        ParentProfileModule,
        routing,
        RegisterManagementModule
    ],
    declarations: [
        LoginComponent,
        AppComponent
    ],
    providers: [
        BookingHolidayService,
        AttendanceService,
        EmailService
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule {}


// WEBPACK FOOTER //
// ./src/holiday/parent/AppModule.ts